// Recovered compiled webpack factory 30637. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "fillLazyItemsTillLeafWithHead", {
      enumerable: !0,
      get: function () {
        return function e(t, r, o, i, s, l, u) {
          if (0 === Object.keys(i[1]).length) {
            r.head = l;
            return;
          }
          for (let c in i[1]) {
            let f,
              d = i[1][c],
              p = d[0],
              h = (0, n.createRouterCacheKey)(p),
              _ = null !== s && void 0 !== s[2][c] ? s[2][c] : null;
            if (o) {
              let n = o.parallelRoutes.get(c);
              if (n) {
                let o,
                  i =
                    (null == u ? void 0 : u.kind) === "auto" &&
                    u.status === a.PrefetchCacheEntryStatus.reusable,
                  s = new Map(n),
                  f = s.get(h);
                ((o =
                  null !== _
                    ? {
                        lazyData: null,
                        rsc: _[1],
                        prefetchRsc: null,
                        head: null,
                        prefetchHead: null,
                        loading: _[3],
                        parallelRoutes: new Map(null == f ? void 0 : f.parallelRoutes),
                        navigatedAt: t,
                      }
                    : i && f
                      ? {
                          lazyData: f.lazyData,
                          rsc: f.rsc,
                          prefetchRsc: f.prefetchRsc,
                          head: f.head,
                          prefetchHead: f.prefetchHead,
                          parallelRoutes: new Map(f.parallelRoutes),
                          loading: f.loading,
                        }
                      : {
                          lazyData: null,
                          rsc: null,
                          prefetchRsc: null,
                          head: null,
                          prefetchHead: null,
                          parallelRoutes: new Map(null == f ? void 0 : f.parallelRoutes),
                          loading: null,
                          navigatedAt: t,
                        }),
                  s.set(h, o),
                  e(t, o, f, d, _ || null, l, u),
                  r.parallelRoutes.set(c, s));
                continue;
              }
            }
            if (null !== _) {
              let e = _[1],
                r = _[3];
              f = {
                lazyData: null,
                rsc: e,
                prefetchRsc: null,
                head: null,
                prefetchHead: null,
                parallelRoutes: new Map(),
                loading: r,
                navigatedAt: t,
              };
            } else
              f = {
                lazyData: null,
                rsc: null,
                prefetchRsc: null,
                head: null,
                prefetchHead: null,
                parallelRoutes: new Map(),
                loading: null,
                navigatedAt: t,
              };
            let m = r.parallelRoutes.get(c);
            (m ? m.set(h, f) : r.parallelRoutes.set(c, new Map([[h, f]])),
              e(t, f, void 0, d, _, l, u));
          }
        };
      },
    }));
  let n = r(69190),
    a = r(86871);
  ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
    void 0 === t.default.__esModule &&
    (Object.defineProperty(t.default, "__esModule", { value: !0 }),
    Object.assign(t.default, t),
    (e.exports = t.default));
}
